<template>
  <div class="winners-list">
    <div class="banner-con page-box" id="matchHome">
      <div class="home-center">
        <Header/>
      </div>

      <div class="winners-list">
        <ul class="winners-menu">
          <li v-for="(item, index) in menuList"
              @click="changMenuList(index)"
              :class="{'active': menuNum == index}"
          >{{item}}</li>
        </ul>

        <div class="grand-prix" v-if="menuNum == 0">
<!--金奖-->
          <div class="gold-prize prize-con" >
            <div class="gold-prize-title prize-con-title">
              <div class="left-con">
                <p>共创2047</p>
                <p class="rank">金奖1名</p>
              </div>
              <div class="right-con">
                <div class="prize">
                  <img src="../assets/images/as_con1_img.png" alt="">
                  <p>价值<span>25,499元</span></p>
                  <p>戴尔Precision 5470工作站</p>
                </div>
                <div class="bonus">
                  <i>+</i>
                  <span class="money">30,000元</span>
                </div>

              </div>
            </div>
            <ul class="gold-prize-img prize-con-list">
              <li v-for="item in goldPriceList" @click="gotoDetail(item.url)">
                <img :src="item.coverUrl" alt="">
                <div class="reveal-info">
                  <p class="reveal-info-title">{{item.workName}}</p>
                  <div class="reveal-info-con">
                    <span class="name">{{item.nickName}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>

<!-- 银奖-->
          <div class="gold-prize prize-con" >
            <div class="gold-prize-title prize-con-title">
              <div class="left-con">
                <p>共创2047</p>
                <p class="rank">银奖2名</p>
              </div>
              <div class="right-con">
                <div class="prize">
                  <img src="../assets/images/as_con2_img.png" alt="">
                  <p>价值<span>10,499元</span></p>
                  <p>戴尔 Precision 3571 工作站</p>
                </div>
                <div class="bonus">
                  <i>+</i>
                  <span class="money">10,000元</span>
                </div>

              </div>
            </div>
            <ul class="gold-prize-img prize-con-list">
              <li v-for="item in silverPriceList" @click="gotoDetail(item.url)">
                <img :src="item.coverUrl" alt="">
                <div class="reveal-info">
                  <p class="reveal-info-title">{{item.workName}}</p>
                  <div class="reveal-info-con">
                    <span class="name">{{item.nickName}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <!-- 铜奖-->
          <div class="gold-prize prize-con" >
            <div class="gold-prize-title prize-con-title">
              <div class="left-con">
                <p>共创2047</p>
                <p class="rank">铜奖5名</p>
              </div>
              <div class="right-con">
                <div class="prize">
                  <img src="../assets/images/as_con3_img.png" alt="">
                  <p>价值<span>4,269元</span></p>
                  <p>戴尔 UltraSharp 24 系列显示器</p>
                </div>
                <div class="bonus">
                  <i>+</i>
                  <span class="money">1,000元</span>
                </div>

              </div>
            </div>
            <ul class="gold-prize-img prize-con-list">
              <li v-for="item in bronzePriceList" @click="gotoDetail(item.url)">
                <img :src="item.coverUrl" alt="">
                <div class="reveal-info">
                  <p class="reveal-info-title">{{item.workName}}</p>
                  <div class="reveal-info-con">
                    <span class="name">{{item.nickName}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>


          <!--人气奖-->
          <div class="gold-prize prize-con" >
            <div class="gold-prize-title prize-con-title">
              <div class="left-con">
                <p>共创2047</p>
                <p class="rank">最佳人气奖5名</p>
              </div>
              <div class="right-con">
                <div class="prize">
                  <img src="../assets/images/as_con4_img.png" alt="">
                  <p>价值<span>2,169元</span></p>
                  <p>戴尔 UltraSharp 4k 网络摄像头</p>
                </div>
              </div>
            </div>
            <ul class="gold-prize-img prize-con-list">
              <li v-for="item in renqiPriceList" @click="gotoDetail(item.url)">
                <img :src="item.coverUrl" alt="">
                <div class="reveal-info">
                  <p class="reveal-info-title">{{item.workName}}</p>
                  <div class="reveal-info-con">
                    <span class="name">{{item.nickName}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <ul class="helper-award" v-if="menuNum != 0">
            <li v-for="item in popularityAwardList">{{item}}</li>
        </ul>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
export default {
  name: "WinnersList",
  data() {
    return{
      menuList: ['征集大奖', '助力达人奖'],
      menuNum: 0,

      // 金奖
      goldPriceList: [
        {
          workName: 'PROLOGUE 启',
          nickName:'DOUBLE-X',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221019/634ff1eed15fa.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'11',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=43',
        },
      ],

      // 银奖
      silverPriceList: [
        {
          workName: '「DELL Precision 2047号」',
          nickName:'老汤姆',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221018/634eca3f2ea82.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'11',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=39',
        },
        {
          workName: 'DELL Precision 2047号［未来舰］',
          nickName:'Jesse靖翔',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221023/6354aedc861ab.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'11',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=53',
        }
      ],

      // 铜奖
      bronzePriceList: [
        {
          workName: 'DELL Precision 2047号',
          nickName:'虾饺',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221017/634cf288481e4.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'11',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=33',
        },
        {
          workName: '奋进号-跨越宇宙边界',
          nickName:'七区',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221025/63575628883df.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'11',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=69',
        },
        {
          workName: '【Dell Precision 2047】 × 聚变',
          nickName:'Jor',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221025/635773c3561c9.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'11',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=70',
        },
        {
          workName: 'PRECISION-2047-精度号——模块式穿越作业飞船',
          nickName:'苏瓦西里畅',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221018/634d948b81cc0.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'11',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=37',
        },
        {
          workName: 'Dell precision 2047 + INFINITE极跃号',
          nickName:'科幻者Mr丶JF',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221010/6343fae5601b8.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'11',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=10',
        }
      ],


      // 助力达人奖
      price3List: [15323411833,13962898673,13962816488,18621965724,15143281000,18616758762,13911793678,15854449752,15129156200,18786312376,15970601605,13625220998,15349806368,18601684757,13302344896,13211130619,15906633132,18267949976,17607975737,15372021955,19917182502,15869452280,18305967357,15670053171,15851802036,17825651314,15015802278,16646432333,15885444202,13435780855,13522096176,18675148666,13542980277,13500006595,15839226016,18179860014,13799190776,15586510333,15633885878,13586137155,18814153848,17745107193,18367277429,18940877807,15914804216,13962839443,18710566856,18212303866,17815502785,13810404929],

      // 人气奖
      renqiPriceList: [
        {
          workName: 'DELL Precision ---LEI YUN(雷云号）',
          nickName:'嘉伦哥哥',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221015/634a7112afd8f.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'392',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=25',
        },
        {
          workName: 'DELL Precision 2047号 x 大鹏',
          nickName:'世纪初的名侦探',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221019/634ed47442f77.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'388',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=40',
        },
        {
          workName: 'Dell Precision 2047 X 先行架构者',
          nickName:'雷珀林阿里纳斯',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221021/6352573581f1f.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'335',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=47',
        },
        {
          workName: '戴尔号飞船',
          nickName:'lizi',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221013/6347a0ade47ab.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'315',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=17',
        },
        {
          workName: 'DELL Precision 2047+开拓者',
          nickName:'VK',
          coverUrl:'https://www.dellemc-solution.com/files/match-pics/20221013/63481cb1796a6.jpg?x-oss-process=image/resize,s_1200/quality,q_80/auto-orient,0/interlace,1/format,jpg',
          likeNum:'254',
          url:'https://www.dellemc-solution.com/campaigns/precision-25th-index/#/opusInfo?id=18',
        }
      ],

      // 页面级变量
      pageRecord:{
        title:'precision25周年',
        module: 'precision25周年',
        category1: '获奖列表',
      },
    }
  },
  computed: {
    popularityAwardList() {
     let listArr = [];
     this.price3List.forEach(item=>{
       listArr.push(item.toString().replace(/(\d{3})(\d{4})(\d{4})/,"$1****$3"))
     });
      return listArr;
    }
  },
  methods: {
    changMenuList(index) {
      this.menuNum = index;
    },

    gotoDetail(url) {
      window.open(url)
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/WinnersList/pc";
@import "../assets/css/WinnersList/wap";
</style>
